import axios from 'axios';
import routes from '../routes';
import { AccountDeletionFormRequest } from '../../structures/requests/AccountDeletionFormRequest';

/**
 * @param request
 */
const createAccountDeletionRequestForm = async (
  request: AccountDeletionFormRequest,
): Promise<void> => {
  await axios
    .post(
      routes.API_ACCOUNT_DELETION_REQUEST_POST,
      request,
      { headers: { Accept: 'application/json' } },
    );
};

export default createAccountDeletionRequestForm;
